module.exports = __webpack_public_path__ + "static/img/hb_52-min.90815bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_52-min.png
// module id = htwr
// module chunks = 1